// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1X9R6","footer":"styles_footer___L31P"};